module.exports = [
	{
		"fileName": "1.jpg",
		"title": "长门",
		"desc": "长门号作为八八舰队计划一号舰，于1917年8月28日于吴港海军造船厂动工，1919年11月9日下水，1920年11月25日竣工。第七代日本联合舰队旗舰。其他依次是防护巡洋舰“松岛”，战舰“三笠”，战舰“敷岛”，战舰“朝日”，战舰“金刚”，战舰“山城”，战舰“长门”，战舰“陆奥”，战舰“大和”，战舰“武藏”，轻巡洋舰“大淀”。扶桑：我不想输给金刚和山城和长门和陆奥和大和和武藏和大淀……"
	},
	{
		"fileName": "2.jpg",
		"title": "陆奥",
		"desc": "陆奥号战列舰是旧日本海军长门级战列舰的二号舰。长门级战列舰由日本自行设计建造，被称为“第一级纯日本血统的战舰”。在华盛顿海军条约生效的期间，旧日本海军中威力最大的战列舰之一（唯一击沉海军假日7巨头的一艘Big7），也是同期世界上战斗力最强的战列舰之一。和长门一同被认为是旧日本海军的象征，而被当时的日本国民所熟知。"
	},
	{
		"fileName": "3.jpg",
		"title": "伊势",
		"desc": "以位于现在三重县的中央部分的伊势国命名的伊势级（原定为扶桑级三号舰）战列舰，后改为航空战列舰。伊势级战列舰与扶桑级的区别，在外形上主要体现在：伊势级在三脚前桅上逐步增加射击指挥及观测设施，逐渐形成日本风格的塔式桅楼，而且舰体后部比较 肥 宽大，而且即使经过一次大改和一次航空改造，船体前后部的衔接线依旧十分明显."
	},
	{
		"fileName": "4.jpg",
		"title": "日向",
		"desc": "日向配屬於第一艦隊第一戰隊。並為最新銳的戰列艦。在「長門」竣工之前為聯合艦隊旗艦。1940年（昭和15年）6月22日至7月10日期間作為偽滿州國康德帝（愛新覺羅溥儀）訪日時的座乘艦。"
	},
	{
		"fileName": "5.jpg",
		"title": "雪风",
		"desc": "雪风（ゆきかぜ）是旧日本海军的阳炎级驱逐舰8号舰。“雪风”于1939年（昭和14年）3月24日下水，并在1940年（昭和15年）1月20日于佐世保海军工厂竣工。曾参与过16次以上的作战并取得战果，而且以近乎丝毫无损的状态存留至战争结束，因此被称为“奇迹的驱逐舰”（奇跡の駆逐艦）。其幸运度有着“吴的雪风，佐世保的时雨”（呉の雪風、佐世保の時雨）之称。"
	},
	{
		"fileName": "6.jpg",
		"title": "赤城",
		"desc": "旧日本海军“天城”级重型空母二号舰，第一航空舰队旗舰、第一航空战队“赤城（あかぎ）”。作为日本最大的航空母舰（除信浓）和最初建造的大型航母，赤城一直被视为机动部队的象征：帝国海军于1928年以赤城为旗舰组建第一航空战队、1934年又以她为旗舰组建第二航空战队、1941年第一航空舰队组建，赤城再次依然作为整个机动部队的旗舰而存在，堪称日本海军航空兵的摇篮。"
	},
	{
		"fileName": "7.jpg",
		"title": "加贺",
		"desc": "旧日本海军第一航空战队重型空母“加賀（かが，Kaga）”。原始设计是战列舰，作为“八八舰队计划”的一部分，1920年7月开工，由神户川崎船厂（カワサキ，kawasaki）建造。1921年11月17日下水。"
	},
	{
		"fileName": "8.jpg",
		"title": "苍龙",
		"desc": "舊日本海軍第二航空戰隊中型空母「蒼龍（そうりゅう / さうりう）」。有別於赤城與加賀為戰艦改裝，蒼龍與飛龍最早的設計是「航空巡洋艦」；是為了在華盛頓海軍條約之下，仍然擁有一定的海上制空權。後來卻發現，同時要載很多的飛機與大炮是行不通的，而轉設計為專職的航空母艦。而有了赤城與加賀的改裝經驗後，以更成熟的技術，蒼龍與飛龍建造成，比赤城與加賀性能更高的航空母艦。"
	},
	{
		"fileName": "9.jpg",
		"title": "飞龙",
		"desc": "舊日本海軍第二航空戰隊所屬中型正規航母「飛龍（ひりゅう）」。飛龍和其姐妹蒼龍（雖然是姐妹，但是非同艦型）都是屬於第二次艦船補充計劃（丸二計畫）中建造的空母。本來設計是蒼龍級空母的二號艦，但是由於發生了友鶴事件和第四艦隊事件，使得日本全面放棄了較為先進但受當時技術限制導致艦體強度不足的焊接工法，全面改回建造速度緩慢、增加重量、但在當時比較可靠的鉚接工法造艦。對建造中的飛龍也進行了修正設計，成品與蒼龍號相差甚遠，獨自成級。"
	},
	{
		"fileName": "10.jpg",
		"title": "岛风",
		"desc": "「島風」是舊日本海軍於1941年動工的新型驅逐艦，屬於丙型驅逐艦，即計劃中的「完美艦隊驅逐艦」。島風於1941年在舞鶴海軍工廠開工，1943年5月10日完工。服役後的島風號編入以訓練為主的第十一水雷戰隊，參與了1943年7月的基斯卡島大撤退，及1944年的菲律賓海海戰。在1944年11月8日奧爾莫克灣戰役中，島風在迴避美國海軍第38特遣艦隊飛機的攻擊時，雖然躲過了多發航彈的直接命中，但動力艙被艦載機機炮槍多次命中，由於損害管理不及時，因鍋爐過熱引起爆炸而沉沒。1945年1月10日，島風被除籍。"
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/imageDatas.json
 ** module id = 139
 ** module chunks = 0
 **/